(function () {
  const configNode = document.querySelector('[data-independent-mandate-consent-config]');
  const popup = document.querySelector('[data-independent-mandate-consent]');
  if (!configNode || !popup) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    console.error('Invalid independent mandate config:', error);
    return;
  }

  const checkbox = popup.querySelector('[data-independent-mandate-check]');
  const checkWrap = popup.querySelector('[data-independent-mandate-check-wrap]');
  const acceptBtn = popup.querySelector('[data-independent-mandate-accept]');
  const rejectBtn = popup.querySelector('[data-independent-mandate-reject]');
  const notice = popup.querySelector('[data-independent-mandate-notice]');
  const reopenBtn = popup.querySelector('[data-independent-mandate-reopen]');
  const viewer = popup.querySelector('[data-independent-mandate-viewer]');
  let isSubmitting = false;

  function setNotice(message) {
    if (!notice) return;
    notice.textContent = message;
    notice.hidden = !message;
  }

  function syncAcceptState() {
    if (!acceptBtn) return;
    const canAccept = !isSubmitting && !!checkbox && checkbox.checked && !checkbox.disabled;
    acceptBtn.disabled = !canAccept;
  }

  function setLoading(loading) {
    isSubmitting = loading;
    popup.classList.toggle('is-loading', loading);
    if (checkbox) checkbox.disabled = loading;
    if (rejectBtn) rejectBtn.disabled = loading;
    if (acceptBtn) acceptBtn.textContent = loading ? 'Guardando...' : 'Aceptar';
    syncAcceptState();
  }

  function lockFlow() {
    popup.hidden = false;
    document.body.classList.add('independent-mandate-consent-open');
  }

  function unlockFlow() {
    popup.hidden = true;
    document.body.classList.remove('independent-mandate-consent-open');
    popup.remove();
  }

  function handleReject() {
    setNotice('No puedes continuar usando la plataforma sin aceptar el contrato de mandato.');
    if (viewer) viewer.hidden = true;
    if (reopenBtn) reopenBtn.hidden = false;
    syncAcceptState();
  }

  function reopenContract() {
    if (viewer) viewer.hidden = false;
    if (checkWrap) checkWrap.hidden = false;
    if (reopenBtn) reopenBtn.hidden = true;
    setNotice('');
    syncAcceptState();
  }

  async function acceptConsent() {
    if (!config.email) {
      setNotice('No fue posible identificar el correo del usuario.');
      return;
    }

    if (!checkbox || !checkbox.checked) {
      setNotice('Debes aceptar el contrato para continuar.');
      return;
    }

    setNotice('');
    setLoading(true);

    const isLocalDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const apiBaseUrl = (isLocalDev ? 'http://localhost:8080' : config.apiBaseUrl || '').replace(/\/$/, '');

    if (!apiBaseUrl) {
      setNotice('No fue posible conectar el servicio de consentimiento. Contacta a soporte.');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${apiBaseUrl}/customers/mandate-consent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: config.email }),
      });

      if (!response.ok) {
        throw new Error(`Mandate consent failed: ${response.status}`);
      }

      unlockFlow();
    } catch (error) {
      console.error('Error saving independent mandate consent:', error);
      setNotice('No fue posible registrar tu aceptación. Inténtalo nuevamente.');
    } finally {
      setLoading(false);
    }
  }

  if (checkbox) {
    const onCheck = function () {
      if (checkbox.checked) setNotice('');
      syncAcceptState();
    };
    checkbox.addEventListener('change', onCheck);
    checkbox.addEventListener('input', onCheck);
  }

  if (acceptBtn) acceptBtn.addEventListener('click', acceptConsent);
  if (rejectBtn) rejectBtn.addEventListener('click', handleReject);
  if (reopenBtn) reopenBtn.addEventListener('click', reopenContract);

  if (reopenBtn) reopenBtn.hidden = true;
  syncAcceptState();
  lockFlow();
})();
